module.exports = __webpack_public_path__ + "img/set.f9dc1666.png";